import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
`;

export const Image = styled.img<{width?: number; height?: number}>`
  width: ${({width}) => width};
  height: ${({height}) => height};
  overflow: visible;
`;
